<template>
<popup :showFlag="showFlag"
       @onShowpop="onShowpop"
       :mask="false">
  <div class="closewrap">
    <div class="scroll-div_H">
      <div class="closeitem" :class="[chooseKey===''?'activeclose':'']"
           @click="choosekey('')">
        <img src="./img/noclose.png" class="itemimg"/>
        <div class="itemname">无正装</div>
      </div>
      <div class="closeitem" :class="[chooseKey===item.key?'activeclose':'']"
           v-for="(item, index) in closes[typename]"
           :key="item.key"
            @click="choosekey(item.key)">
        <img :src="item.value" class="itemimg"/>
        <div class="itemname">{{typename|getName}}{{index+1}}</div>
      </div>
      <div class="w16"></div>
    </div>
  </div>
  <duicuo @onCancel="onCancel"
          @onOk="onOk">
    <div class="typegroup">
      <div class="zhuang" :class="[typename==='girl'?'activeType':'']" @click="typename = 'girl'">女装</div>
      <div class="zhuang" :class="[typename==='kid'?'activeType':'']" @click="typename = 'kid'">童装</div>
      <div class="zhuang" :class="[typename==='boy'?'activeType':'']" @click="typename = 'boy'">男装</div>
    </div>
  </duicuo>
</popup>
</template>

<script>
import popup from '@/components/popup'
import duicuo from '@/components/duicuo/duicuo'
export default {
  name: 'changeclose',
  props: {
    showFlag: {
      default: false,
      type: Boolean
    },
    closes: {
      default: () => {},
      type: Object
    },
    chooseKey: {
      default: '',
      type: String
    }
  },
  data () {
    return {
      typename: 'girl'
    }
  },
  methods: {
    onShowpop () {
      this.$emit('onCloseClothes')
    },
    choosekey (key) {
      if (this.chooseKey === key) {
        return
      }
      this.$emit('onChooseClothes', key)
    },
    initval () {
      this.typename = 'girl'
    },
    onCancel () {
      this.initval()
      this.$emit('onInitVal')
    },
    onOk () {
      this.$emit('onCloseKey')
    }
  },
  components: {
    popup,
    duicuo
  },
  filters: {
    getName (typename) {
      const obj = {
        boy: 'M',
        girl: 'W',
        kid: 'K'
      }
      return obj[typename]
    }
  }
}
</script>

<style scoped>
.closewrap{
  background-color: #F7F7F7;
  border-top-left-radius: .32rem;
  border-top-right-radius: .32rem;
  padding:.54rem 0 .54rem .32rem;
  box-shadow: 0 0 .4rem rgba(0,0,0,0.2);
}
.scroll-div_H{
  display: flex;
  display: -webkit-flex;
  overflow: hidden;
  overflow-x: auto;
}
.w16{
  width:.16rem;
  height:.16rem;
  flex-shrink: 0;
}
.closeitem{
  width:1.4rem;
  border-radius: .12rem;
  overflow: hidden;
  background-color: white;
  border:.02rem solid #F7F7F7;
  flex-shrink: 0;
  margin-right: .16rem;
}
.activeclose{
  border:.02rem solid #4710ED;
}
.activeclose .itemname{
  background-color: #4710ED;
  color:white;
}
.closeitem:first-child{
  margin-right: .48rem;
}
.itemimg{
  width:100%;
  height:1.12rem;
  object-fit: cover;
  display: block;
}
.itemname{
  text-align: center;
  overflow: hidden;
  height:.32rem;
  font-size: .2rem;
  color:#5A5A5A;
  display: flex;
  display: -webkit-flex;
  align-items: center;
  justify-content: center;
  background-color: white;
}
.typegroup{
  display: flex;
  display: -webkit-flex;
  font-size: .28rem;
  color:#303133;
}
.activeType{
  color:#4710ED;
}
.zhuang{
  padding:.1rem;
}
.zhuang:nth-child(2){
  margin:0 .64rem;
}
</style>
